import { ServerForm } from '@uplift/ui-v2';
import { NoteSection } from '../../notes-page/components/NoteSection';
import { SessionFormField, SessionFormFieldsGroup } from '@uplift/api';
import { Box } from '@mui/material';
import { useAmendSectionStyles } from './styles';
import { ClaimCorrectionFormType } from '@uplift/types';
import { useFormikContext } from 'formik';
import { NoteSectionCloseButton } from '../../notes-page/components/NoteSectionCloseButton';
import { useMemo } from 'react';
import { EMPTY_STRING } from '@uplift/constants';

export type AmendOtherSectionProps = {
  reason: (SessionFormField | SessionFormFieldsGroup)[];
  description: (SessionFormField | SessionFormFieldsGroup)[];
  open: boolean;
};

export const AmendOtherSection: React.VFC<AmendOtherSectionProps> = ({ open, reason, description }) => {
  const { classes } = useAmendSectionStyles();
  const formik = useFormikContext<ClaimCorrectionFormType>();

  const handleClose = () => {
    formik.setFieldValue('claim.other_field_toggle', false);
    formik.setFieldValue('claim.other_code_change_reason', null);
    formik.setFieldValue('claim.code_change_description', null);
  };

  const closeIcon = useMemo(() => {
    if (formik?.values.claim['other_code_change_reason'] !== null && formik?.values.claim['other_code_change_reason'] !== EMPTY_STRING) {
      return true;
    }
    if (formik?.values.claim['code_change_description'] !== null && formik?.values.claim['code_change_description'] !== EMPTY_STRING) {
      return true;
    }
    return false;
  }, [ formik?.values.claim ]);

  if (!open) {
    return null;
  }

  return (
    <NoteSection
      title="Amend Other"
      onDelete={<NoteSectionCloseButton onDelete={handleClose} closeIcon={closeIcon} />}
      className={classes.otherNoteSection}
    >
      <Box className={classes.section}>
        <ServerForm fields={reason} namespace="claim"/>
      </Box>
      <Box className={classes.otherDescription}>
        <ServerForm fields={description} namespace="claim"/>
      </Box>
    </NoteSection>
  );
};
